<template>
	<div class="home">

		<!-- <div class="mobile" style="backgroundImage: 'url('@/assets/images/store_photos/hallway.jpg')'"> -->
		<div class="mobile">
		<!-- background: url("/src/assets/images/store_photos/hallway.jpg"); -->
			<!-- <img id="serene_logo_ch" src="@/assets/images/logos/serene_logo_ch.png" /> -->
			<!-- <img id="backgroundImage" src="@/assets/images/store_photos/hallway.jpg" /> -->

			<div class="displayCard" id="banner">
				<div class="text"> 
					New!<br> {{ display.sect1.text }} 
					<router-link to="/productpage/1100">
						<div class="shopNowButton">
							SHOP NOW
						</div>
					</router-link>

				</div>
				<img :src="display.sect1.img" />
			</div>

			<div id="thumbnails">
				<div class="displayCard">
					<div class="text"> 
						返本賦原全效面膜
						<router-link to="/productpage/1000">
							<div class="shopNowButton"> SHOP NOW </div>
						</router-link>
					</div>
					<img src="@/assets/images/front_page/moisturizing.jpg" />
				</div>

				<img src="@/assets/images/front_page/duo.jpg" />

				<div class="displayCard">
					<div class="text"> 
						有夠白面膜
						<router-link to="/productpage/1002">
							<div class="shopNowButton"> SHOP NOW </div>
						</router-link>
					</div>
					<img src="@/assets/images/front_page/whitening.jpg" />
				</div>
			</div>

		</div>

		<div class="desktop">
			<div class="displayCard" id="sect1">
				<div class="text"> 
					New!<br>
					{{ display.sect1.text }} 

					<router-link to="/productpage/1100">
						<div class="shopNowButton">
							SHOP NOW
						</div>
					</router-link>

				</div>
				<img :src="display.sect1.img" />
			</div>

			<div id="sect2">
				<div class="displayCard">
					<div class="text"> 
						返本賦原全效面膜
						<router-link to="/productpage/1000">
							<div class="shopNowButton"> SHOP NOW </div>
						</router-link>

					</div>
					<img src="@/assets/images/front_page/moisturizing.jpg" />
				</div>

				<img src="@/assets/images/front_page/duo.jpg" />

				<div class="displayCard">
					<div class="text"> 
						有夠白面膜
						<router-link to="/productpage/1002">
							<div class="shopNowButton">
								SHOP NOW
							</div>
						</router-link>

					</div>
					<img src="@/assets/images/front_page/whitening.jpg" />
				</div>
			</div>
		</div>


  </div>
</template>

<script>
import Styles from "./styles.scss";

export default {
  name: "Home",
  data() {
		let display = {
			"sect1": {
				text: " 凝靜美學專業實驗團隊，歷經3年不斷研發、調整配方，終於即將在2020年中上市「有夠嫩精萃乳霜」，具備三大美麗的能力，賦活肌膚能量，散發透亮光采，同時保濕鎖水，支援肌膚補充水分並維持細胞最大含水量，讓肌膚維持最佳狀態。 ", 
				img: require("@/assets/images/front_page/sect1.jpg")
			}

		};
    return {
      Styles,
			display
    };
  },
};
</script>
